const TableHeader = (props) => {
  const labels = (props || {}).labels || {};
  return <thead>
    <tr>
      <th className="bezeichnung" colSpan={3}>Lieferadresse</th>
      <th className="edelmetall" colSpan={2}>{labels.edelmetall || ""}</th>
      <th className="sorten" colSpan={2}>{labels.sorten || ""}</th>
    </tr>
    <tr>
      <th className="">{labels.lieferadressenNummer || ""}</th>
      <th className="header-2">{labels.shops || ""}</th>
      <th className="header-2">{labels.bezeichnung || ""}</th>
      <th>{labels.lieferbar || ""}</th>
      <th className="text-end">{labels.edelmetallMaxBetrag || ""}</th>
      <th>{labels.lieferbar || ""}</th>
      <th className="text-end">{labels.sortenMaxBetrag || ""}</th>
    </tr>
  </thead>;
};
export default TableHeader;
